import React from "react";
import { Box } from "./style";
import { getToken } from "../../lib/tokenManager";
import Modal from "./modal";
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      currentShow: 0
    };
  }

  bigAdd() {
    let files = this.props.files;
    if (files && files.length < this.props.limit) {
      return (
        <React.Fragment>
          <label htmlFor="file" className="add-file-big">
            <i className="icon mapsa-plus" />
          </label>
        </React.Fragment>
      );
    }
  }

  modalView() {
    if (this.state.modalStatus) {
      return (
        <Modal
          files={this.props.files}
          current={this.state.currentShow}
          whitOutProject={this.props.whitOutProject}
          remove={i => {
            this.remove(i);
          }}
          close={() => {
            this.setState({
              modalStatus: false
            });
          }}
        />
      );
    }
  }

  src(file) {
    if(this.props.whitOutProject){
      return (
        process.env.REACT_APP_API_URL +
        "/imagesWeb/" +
        file.id +
        "?access_token=" +
        getToken("accessToken")
      );
    }else if (file.id) {
      return (
        process.env.REACT_APP_API_URL +
        "/projects/" +
        localStorage.getItem("project_id") +
        "/imagesWeb/" +
        file.id +
        "?access_token=" +
        getToken("accessToken")
      );
    } else {
      return window.URL.createObjectURL(file);
    }
  }
  render() {
    const { files, hideImages } = this.props;
    return (
      <Box>
        {!hideImages && (
          <div className="files">
            {files.map((file, i) => (
              <div
                className="image-slider-file"
                key={i}
                style={{
                  backgroundImage: `url(${this.src(file)})`
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    modalStatus: true,
                    currentShow: i
                  });
                }}
              />
            ))}
            {this.bigAdd()}
          </div>
        )}
        {hideImages && (
          <div
            className="files-number"
            onClick={
              files.length > 0
                ? (e) => {
                    e.stopPropagation();
                    this.setState({
                      modalStatus: true,
                      currentShow: 0
                    });
                  }
                : () => {}
            }
          >
            {files.length > 0 ? files.length : "-"}
          </div>
        )}
        {this.modalView()}
      </Box>
    );
  }
}
export default Index;
